module.exports = __webpack_public_path__ + "img/ic-actions-check.c871bfa8.svg";